import Backbone from 'backbone';

import GetOFCONUSDesktopByOrderId from '../services/GetOFCONUSDesktopByOrderId';
import GetOFMFDMaintenanceByOrderId from '../services/GetOFMFDMaintenanceByOrderId';
import GetOFPRTNRByOrderId from '../services/GetOFPRTNRByOrderId';
import GetOFCONUSWideByOrderId from '../services/GetOFCONUSWideByOrderId';
import GetOfWideFormatByOrderId from '../services/GetOfWideFormatByOrderId';
import GetOFMFDOrderByOrderId from '../services/GetOFMFDOrderByOrderId';
import GetOFMFDRelocationByOrderId from '../services/GetOFMFDRelocationByOrderId';
import GetOFConusByOrderId from '../services/GetOFConusByOrderId';
import GetOFOCONUSByOrderId from '../services/GetOFOCONUSByOrderId';
import GetOFDefaultByOrderId from '../services/GetOFDefaultByOrderId';
import OrderGeneralView from '../views/OrderGeneralView';

export default async function loadOrderGeneralView(orderDetails) {
  let order;
  let isOtherCountry = false; // anything that's not CONUS or AK/HI/PR/GU
  switch (orderDetails.orderTypeId) {
    case '1':
      order = await GetOFMFDOrderByOrderId(orderDetails.orderId);
      break;
    case '2':
    case '13':
    case '14':
    case '15':
      order = await GetOFPRTNRByOrderId(orderDetails.orderId);
      break;
    case '3':
      order = await GetOFMFDOrderByOrderId(orderDetails.orderId);
      break;
    case '4':
      order = await GetOFMFDMaintenanceByOrderId(orderDetails.orderId);
      break;
    case '5':
      order = await GetOFCONUSWideByOrderId(orderDetails.orderId);
      break;
    case '6':
    case '10':
    case '11':
      order = await GetOFCONUSDesktopByOrderId(orderDetails.orderId);
      break;
    case '12':
      order = await GetOFMFDRelocationByOrderId(orderDetails.orderId);
      break;
    case '16':
    case '20':
      order = await GetOFConusByOrderId(orderDetails.orderId);
      break;
    case '17':
      order = await GetOfWideFormatByOrderId(orderDetails.orderId);
      break;
    case '18':
    case '21':
      order = await GetOFOCONUSByOrderId(orderDetails.orderId);
      break;
    case '22':
    case '23':
    case '24':
    case '25':
    case '26':
      order = await GetOFDefaultByOrderId(orderDetails.orderId);
      isOtherCountry = true;
      break;
  }

  return new OrderGeneralView({
    model: new Backbone.Model({
      orderDetails,
      order,
      isReadOnly: !orderDetails.editable,
      isOtherCountry: isOtherCountry
    })
  });
}
